/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';
import type { GridColDef, GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';

export const renderCellContent = <R extends GridValidRowModel>(
  col: GridColDef<R>,
  row: R,
  rowId: string | number
): ReactNode => {
  const baseParams = {
    id: rowId,
    row,
    colDef: { ...col, computedWidth: 0 },
    api: null as any,
    field: col.field,
    rowNode: null as any,
    cellMode: 'view' as const,
    hasFocus: false,
    tabIndex: -1 as const,
  };

  const valueGetterParams = {
    ...baseParams,
    value: row[col.field as keyof R],
  };

  const value = col.valueGetter
    ? (col.valueGetter as (...args: any[]) => any)(valueGetterParams.value, row, col, null)
    : valueGetterParams.value;

  const valueFormatterParams = {
    ...baseParams,
    value,
  };

  const formattedValue = col.valueFormatter
    ? (col.valueFormatter as (...args: any[]) => any)(value, row, col, null)
    : value;

  if (col.renderCell) {
    const renderCellParams: GridRenderCellParams<R> = {
      ...baseParams,
      value,
      formattedValue,
    };

    return col.renderCell(renderCellParams);
  }

  return formattedValue;
};
